import { useEditInstructions } from './useEditInstructions'
import { useEditQuality } from './useEditQuality'
import { useEditSettings } from './useEditSettings'
import { useEditTaskMediaManagement } from './useEditTaskMediaManagement'
import { useGetPipeline } from './useGetPipeline'
import { useGetPipelineJobForEngagement } from './useGetPipelineJobForEngagement'

export const pipeline = {
  getPipeline: useGetPipeline,
  getPipelineJobForEngagement: useGetPipelineJobForEngagement,
  editInstructions: useEditInstructions,
  editSettings: useEditSettings,
  editQuality: useEditQuality,
  editMediaManagement: useEditTaskMediaManagement,
}
